import { BASE_URL } from './Config.js';

export class WorkFlowService {
  createBCCFromDevis = async (devisId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      //  Appel au WorkflowController pour la transformation
      const response = await fetch(`${BASE_URL}/workflow/devis-to-bcc/${devisId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Erreur lors de la transformation Devis -> BCC');
      }
      return await response.json();
    } catch (error) { 
      console.error('Error creating BCC from devis:', error); 
      throw error; 
    }
  };

    syncAllClosedDevis = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/workflow/sync-all-closed-devis`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur synchronisation');
      return await response.text();
    } catch (error) { 
      console.error('Error syncing closed devis:', error); 
      throw error; 
    }
  };

  transformBccToAchatLines = async (bccId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/workflow/bccline-to-achatline/${bccId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erreur transformation BCC -> Achat');
      return await response.text(); // Votre controller renvoie un String de succès
    } catch (error) { 
      console.error('Error transforming BCC to Achat:', error); 
      throw error; 
    }
  };

  // Approvisionnement → BCF (Transformation directe)
  transformApprovisionnementToBcf = async (approvisionnementId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/workflow/approvisionnement-to-bcf/${approvisionnementId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Erreur lors de la transformation Approvisionnement -> BCF');
      }
      return await response.json(); // Retourne le BCFDTO créé
    } catch (error) { 
      console.error('Error transforming Approvisionnement to BCF:', error); 
      throw error; 
    }
  };

  // Dans WorkFlowService.js
  transformAchatLineToBcf = async (achatLineId) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error("Aucun token d'accès trouvé.");

    const response = await fetch(`${BASE_URL}/workflow/achatline-to-bcf/${achatLineId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Erreur transformation AchatLine -> BCF');
    return await response.json();
  };
  
  // Dans src/services/WorkFlowService.js
  syncAllClosedAchatLines = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error("Aucun token d'accès trouvé.");

    const response = await fetch(`${BASE_URL}/workflow/sync-all-closed-achatlines`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Erreur lors de la synchronisation en masse');
    return await response.text();
  };

  

  //  Le nom doit être EXACTEMENT celui que le frontend appelle
  syncAllClosedApprovisionnementLines = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error("Aucun token d'accès trouvé.");

    const response = await fetch(`${BASE_URL}/workflow/sync-all-closed-approvisionnements`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Erreur lors de la synchronisation des approvisionnements');
    }
    return await response.text();
  };

  //  Transformer un BCC en Mandat (Pré-remplissage)
  transformBccToMandat = async (bccId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

     
      // Ex: si votre contrôleur est sur /api/v1/workflow, l'URL sera celle-ci :
      const response = await fetch(`${BASE_URL}/workflow/bcc-to-mandat/${bccId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Erreur lors de la transformation BCC vers Mandat');
      }
      
      // Retourne le MandatDTO créé (contient l'ID du nouveau mandat)
      return await response.json(); 
    } catch (error) {
      console.error('Error transforming BCC to Mandat:', error);
      throw error;
    }
  };
}